// PLUGINS IMPORTS //
import React, { memo } from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import WaveImage1 from "Assets/Images/backgrounds/wave1.svg"

/////////////////////////////////////////////////////////////////////////////

interface PropsType {}

const Background: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <BackgroundStyle />
      <Wave src={WaveImage1} className={"wave1"} />
      {props.children}
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  display: flex;

  .wave1 {
    top: 100px;
    filter: blur(60px) brightness(0.9) grayscale(0.1);
  }
`

const Wave = styled.img`
  position: absolute;
  z-index: -1;
  width: 100%;
`

const BackgroundStyle = styled.div`
  background: linear-gradient(180deg, #1a026c 0%, #46308e 100%);
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: -1;
`

export default memo(Background, memoComparison)
